/**
 * Unternehmenskürzel für die Anmeldung aus `/login?workspace=…`. Der Einladungslink trägt es
 * über die Aktivierung bis hierher; ein Kürzel ist kein Geheimnis, aber übernommen wird nur, was
 * eines sein kann. Alles andere bleibt leer, statt ein falsches Feld vorzubelegen.
 */
const WORKSPACE_SLUG = /^[a-z0-9-]{1,80}$/;

export interface LoginSearch {
  workspace?: string;
}

export function loginWorkspacePrefill(value: unknown): string {
  // Der Router liest Query-Werte als JSON: ein Kürzel nur aus Ziffern kommt als Zahl an.
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  const slug = String(value).trim().toLowerCase();
  return WORKSPACE_SLUG.test(slug) ? slug : '';
}

export function parseLoginSearch(search: Record<string, unknown>): LoginSearch {
  const workspace = loginWorkspacePrefill(search.workspace);
  return workspace ? { workspace } : {};
}
